import React, { createContext, useContext, useState, useCallback } from "react"

type SelectedProjectContextType = {
  selectedDestinationId: string | undefined
  setSelectedDestinationId: (id: string | undefined) => void
  selectedActivityId: string | undefined
  setSelectedActivityId: (id: string | undefined) => void
}

const DESTINATION_KEY = "selected_destination_id"
const ACTIVITY_KEY = "selected_activity_id"

const SelectedProjectContext = createContext<SelectedProjectContextType | null>(null)

export const SelectedProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedDestinationId, setDestId] = useState<string | undefined>(
    () => localStorage.getItem(DESTINATION_KEY) ?? undefined
  )
  const [selectedActivityId, setActId] = useState<string | undefined>(
    () => localStorage.getItem(ACTIVITY_KEY) ?? undefined
  )

  const setSelectedDestinationId = useCallback((id: string | undefined) => {
    if (id) {
      localStorage.setItem(DESTINATION_KEY, id)
    } else {
      localStorage.removeItem(DESTINATION_KEY)
    }
    setDestId(id)
  }, [])

  const setSelectedActivityId = useCallback((id: string | undefined) => {
    if (id) {
      localStorage.setItem(ACTIVITY_KEY, id)
    } else {
      localStorage.removeItem(ACTIVITY_KEY)
    }
    setActId(id)
  }, [])

  return (
    <SelectedProjectContext.Provider
      value={{ selectedDestinationId, setSelectedDestinationId, selectedActivityId, setSelectedActivityId }}>
      {children}
    </SelectedProjectContext.Provider>
  )
}

export function useSelectedProject(): SelectedProjectContextType {
  const context = useContext(SelectedProjectContext)
  if (!context) {
    throw new Error("useSelectedProject must be used within a SelectedProjectProvider")
  }
  return context
}
